import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import CustomDialog from "./CustomDialog";
import { useDispatch, useSelector } from "react-redux";
import { setQRScanner } from "store/userSettingsSlice";
import { setShowMassage } from "store/sysSlice";
import { Stack } from "@mui/material";

const QRScanner = () => {
    const dispatch = useDispatch()
    const qrCodeRef = useRef(null);
    const html5QrCodeRef = useRef(null);
    const data = useSelector((state) => state.userSettings?.qRScanner);
    let hasVideo = false

    useEffect(() => {
        if (!hasVideo) {
            hasVideo = true
            setTimeout(() => {
                const html5QrCode = new Html5Qrcode("qr-reader");
                html5QrCodeRef.current = html5QrCode
                html5QrCode.start(
                    { facingMode: "environment" },
                    { fps: 10, qrbox: { width: 250, height: 250 } },
                    (decodedText) => {
                        const decoded = decodedText?.split('-')
                        if (decoded[0] === 'MyBee') {
                            if (data?.callBack)
                                data?.callBack(decoded[1])
                            onClose()
                        }
                        else {
                            dispatch(setShowMassage({ massage: "QR_NOT_FROM_SYS_ERROR", type: "error" }));
                        }
                    },
                    (errorMessage) => { }
                )
                    .catch((err) => { });

                return () => {
                    html5QrCode.stop()
                        .then(res => html5QrCode.clear())
                        .catch((err) => console.error("Stop error: ", err));
                };
            }, 50);
        }
    }, []);

    const onClose = () => {
        html5QrCodeRef.current.stop()
            .then(res => {
                html5QrCodeRef.current.clear()
                dispatch(setQRScanner({ open: false, callBack: () => { } }))
            })
            .catch((err) => {
                dispatch(setQRScanner({ open: false, callBack: () => { } }))
                console.error("Stop error: ", err)
            });

    }

    return (
        <CustomDialog open={data?.open} title='סרוק קוד QR' onClose={onClose}>
            <Stack alignItems="center" justifyContent="center">
                <div id="qr-reader" ref={qrCodeRef} style={{ width: "295px" }} />
            </Stack>
        </CustomDialog>
    );
};

export default QRScanner;

